import { render, staticRenderFns } from "./CultureImpression.vue?vue&type=template&id=06ec2031&scoped=true"
import script from "./CultureImpression.vue?vue&type=script&lang=js"
export * from "./CultureImpression.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec2031",
  null
  
)

export default component.exports